<span>
    <mat-tab-group dynamicHeight class="order-details">
        <mat-tab label="Quote Summary">
            <div class="details-tab">
                <div class="tab-section">
                    <h3>Organizations</h3>
                    <b>Customer:</b> {{details.customer_organization || "Not assigned yet"}} <br />
                    <b>Carrier:</b> {{details.carrier_contact_organization || "Not assigned yet"}} <br />
                </div>
                <div class="tab-section">
                    <h3>Quote Information</h3>
                    <b>Spot Quote #:</b> {{details.spot_quote_id || "-"}} <br />
                    <b>Created Date:</b> {{details.created || "-"}} <br />
                    <b>Effective Date:</b> {{details.effective_date || "-"}} <br />
                    <b>Expiry Date:</b> {{details.expiry_date || "-"}} <br />
                    <b>Shipment Type:</b> {{details.shipment_type || "-"}}<br>
                    <b>Equipment Type:</b> {{details.equipment_type || "-"}}<br><br />
                    <!-- <mat-form-field>
                        <mat-label>Load Details</mat-label>
                        <input #load_details name="load_details" (keyup)="changeLoadDetail(load_details.value)" matInput value={{details.load_details}}>
                    </mat-form-field> -->
                </div>
                <div class="tab-section">
                    <h3>Pickup and Delivery</h3>
                    <b>Pickup Date:</b> {{details.load_start || "-"}} <br />
                    <b>Delivery Date:</b> {{details.load_end || "-"}}
                </div>
                <div class="tab-section" id="addresses">
                    <h3>Locations</h3>
                    <b>Origin</b> {{details.origin_locality || "-"}} <br>
                    <b>Destination</b> {{details.destination_locality || "-"}} <br><br>
                    <button mat-button color="accent" id="map-button" (click)="openMap()">See Trip as Map</button>
                </div>
                <div class="tab-section">
                    <h3>Actions</h3>
                    <button mat-button color="primary" class="action-button" (click)="printQuote()">Print Quote</button>
                    <button mat-button color="primary" class="action-button" (click)="viewQuote()">View Quote
                        Details</button>
                    <button mat-button color="primary" class="action-button" (click)="createQuote()">Create Quote</button>
                    <button mat-button color="warn" class="action-button" (click)="deleteQuote()">Delete Quote</button>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Customer">
            <div class="details-tab">
                <div class="tab-section">
                    <h3>Customer Summary</h3>
                    <b>Customer:</b> {{customer_details.contact_organization || "Not assigned yet"}} <br />
                    <b>Carrier:</b> {{details.carrier_contact_organization || "Not assigned yet"}} <br />
                </div>
                <div class="tab-section">
                    <h3>Customer Address</h3>
                    <b>Street Address:</b> {{customer_address_details['address_street'] || "-"}} <br />
                    <b>City:</b> {{customer_address_details['address_locality'] || "-"}} <br />
                    <b>Region:</b> {{customer_address_details['address_region'] || "-"}} <br />
                    <b>Postal Code:</b> {{customer_address_details['address_postal_code'] || "-"}} <br />
                    <b>Country:</b> {{customer_address_details['address_country'] || "-"}}<br>
                    <b>Notes:</b> {{customer_details['contact_note'] || "-"}}<br><br />
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Sales Rep (Intenal Sales)">
            <div class="details-tab">
                <div class="tab-section">
                    <h3>Sales Information</h3>
                    <b>First Name:</b> {{internal_sales_details.first_name || "-"}} <br />
                    <b>Last Name:</b> {{internal_sales_details.last_name || "-"}} <br />
                    <b>Email Address:</b> {{internal_sales_details['email_address'] || "-"}} <br />
                    <b>Phone Number:</b> {{internal_sales_details['phone_number'] || "-"}} <br />
                    <b>Notes:</b> {{internal_sales_details['notes'] || "-"}} <br /><br /><br />
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Financial">
            <div class="details-tab">
                <div class="tab-section">
                    <h3>Billable Information</h3>
                    <b>Freight:</b> {{financial_details.freight_net_billable || "-"}} <br />
                    <b>Rate Per Mile:</b> {{financial_details.chargeable_rate_per_mile || "-"}} <br />
                    <b>Fuel Surcharge Rate:</b> {{financial_details.fuel_surcharge_rate_billed || "-"}} <br />
                    <b>Fuel Surcharge Plus Rate:</b> {{financial_details['fuel_surcharge_plus_rate_billed'] || "-"}} <br />
                    <b>Beyond:</b> {{financial_details['beyond_billed'] || "-"}} <br />
                    <b>Discount Rate:</b> {{financial_details['discount_rate'] || "-"}} <br /><br />
                </div>
                <div class="tab-section">
                    <h3>Billable Summary</h3>
                    <b>Discount:</b> {{financial_details['discount'] || "-"}} <br />
                    <b>Tax Rate:</b> {{financial_details['tax_rate_billed_multiplier'] || "-"}} <br />
                    <b>Tax:</b> {{financial_details['billable_taxes'] || "-"}} <br />
                    <b>Subtotal:</b> {{financial_details['gross_billed'] || "-"}} <br />
                    <b>Total:</b> {{financial_details['total_charged'] || "-"}} <br />
                </div>
                <div class="tab-section">
                    <h3>Costs Information</h3>
                    <b>Freight:</b> {{internal_sales_details.freight_net_cost || "-"}} <br />
                    <b>Rate Per Mile:</b> {{financial_details.cost_rate_per_mile || "-"}} <br />
                    <b>Fuel Surcharge Rate:</b> {{internal_sales_details.fuel_surcharge_rate_cost || "-"}} <br />
                    <b>Fuel Surcharge Plus Rate:</b> {{internal_sales_details['fuel_surcharge_plus_rate_cost'] || "-"}} <br />
                    <b>Beyond:</b> {{internal_sales_details['beyond_cost'] || "-"}} <br />
                </div>
                <div class="tab-section">
                    <h3>Costs Summary</h3>
                    <b>Tax Rate:</b> {{internal_sales_details['tax_rate_multiplier'] || "-"}} <br />
                    <b>Tax:</b> {{internal_sales_details['costs_taxed'] || "-"}} <br />
                    <b>Subtotal:</b> {{internal_sales_details['gross_costs'] || "-"}} <br />
                    <b>Total:</b> {{internal_sales_details['total_costs'] || "-"}} <br />
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</span>
